import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const HeaderStyled = styled.div<T>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em 1.25em;

  h2 {
    font-size: 0.8em;
    font-weight: 500;
    line-height: 0.8em;
    letter-spacing: 0;
    text-align: left;
  }

  ${({ theme }) =>
    theme.device.mobile &&
    `
  `}
`;
